import '../../styles/SearchHost.css'
import Selector from '../../Selector'
import InfoStatus from '../../InfoStatus'
import Action from '../../Action'
import {fetchData} from '../../../hooks/fetchData'
import { useFetch } from '../../../hooks/useFetch'
import { Suspense, useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl';
import { capitalizeFirstLetter } from '../../../utils/utils'
import { lang } from '../../generales/traduction'

const SearchHost =(props)=>{
    // console.log(props.exceptions_list)
    //console.log(props.downs_list)
    const [resultList,setResultList]=useState([])
    const [inputIp,setInputIP]=useState("")

    const [chekedSearch,setChekedSearch]=useState(true)
    // //console.log(resultList)
    const closeFindedHost=()=>{
        //console.log("cerar poppup")
    }

    const closeFindHost=()=>{
        const popups = document.querySelectorAll('.custom-popup-findHost');
      
      popups.forEach(popup => {

    //    //console.log(popups)

      popup.remove();
      });
      setResultList([])
      setInputIP("")
    }

    function closePopup() {
        //console.log('closepopip')
      }
    const handleSelected=(element)=>{
        setResultList([])
        setChekedSearch(true)
        setFlagSearch(true)
        setInputIP("")
        const latStr = element.latitude || element.location_lat;
        const lonStr = element.longitude || element.location_lon;
        if( latStr.replace(",", ".")>=-90 && latStr.replace(",", ".")<=90){
            const coordinates=[lonStr.replace(",", "."),latStr.replace(",", ".")]
            const popups = document.querySelectorAll('.custom-popup-findHost');

            popups.forEach(popup => {

          //    //console.log(popups)

            popup.remove();
            });
            props.mapAux.setZoom(12);
            props.mapAux.setCenter(coordinates);
            let popup = new mapboxgl.Popup({
                className: 'custom-popup-findHost',

                closeButton: true,

                closeOnClick: false
                })
                .setLngLat(coordinates)
                .setHTML(`<div class='cont-findHost' style='border: 1px solid #ffffff;'>

                    <div class='findHost-txt'>${element.ip}</div>
                    <div class='findHost-close' > </div>
                    </div>`)
                .addTo(props.mapAux);
        }
    }
    
    const [flagSearch,setFlagSearch]=useState(true)
    

    const handleChange=(e)=>{
        
        const term = e.target.value;
        const {name,value}=e.target

        // //console.log(value)

        setInputIP(value)
        validateIp(value)

        if(props.ubiActual.dispId==-1){
          
        }
        const hostArray=(props.ubiActual.dispId==-1)?props.downs_list.data.downs.concat(props.exceptions_list.data):props.downs_list.data.downs.concat(props.devices.data.hosts).concat(props.exceptions_list.data).concat(props.devices.data.host_unknown)//props.downs_list.data.downs:props.devices.data.hosts
        const filteredResults = hostArray.filter((item) => {
          // Convierte todos los valores a cadenas para realizar una búsqueda sin distinción entre mayúsculas y minúsculas
          return Object.entries(item).some(([key, value]) => {
            if (key === 'ip' || key=== 'Host' || key=== 'name' || key=== 'hostid') {
              return String(value).toLowerCase().includes(term.toLowerCase());
            }
            return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
          });
        });

          setResultList(filteredResults)
          
      }

      const validateIp= (ip) => {
        // //console.log("validando correo: ",ip )
        const ipRegex = /^$/;
        // const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        setFlagSearch(result)
        return result;
      };
 const validate = (lat,lng) => {
  const LAT_REGEX = /^-?(?:[0-8]?\d|90)([.,]\d{1,15})?$/;
const LNG_REGEX = /^-?(?:1[0-7]\d|0?\d{1,2}|180)([.,]\d{1,15})?$/;
    const newErr = {
      lat: LAT_REGEX.test(lat?.trim() ?? "") ? "" : "Latitud inválida",
lng: LNG_REGEX.test(lng?.trim() ?? "") ? "" : "Longitud inválida"
      // lat: LAT_REGEX.test(lat.trim()) ? "" : "Latitud inválida",
      // lng: LNG_REGEX.test(lng.trim()) ? "" : "Longitud inválida"
    };
    // setErr(newErr);

    // Devuelve true solo si no hay errores
    return !newErr.lat && !newErr.lng;
  }
    return (
        <div style={{marginBottom: '10px', position: 'relative'}}>
            <div className="f-lbl">{capitalizeFirstLetter(lang[props.languaje]['buscar'])} IP</div>
            <div className="search-box">
                <input 
                    type="text" 
                    placeholder="Buscar IP..." 
                    value={inputIp}
                    onChange={handleChange}
                />
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            </div>
            
            {inputIp !== "" && (
                <div style={{
                    position: 'absolute', 
                    top: '100%', 
                    left: '0', 
                    right: '0', 
                    background: '#fff', 
                    border: '1px solid var(--b2)', 
                    borderRadius: '4px', 
                    maxHeight: '150px', 
                    overflowY: 'auto', 
                    zIndex: 100, 
                    marginTop: '4px',
                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
                }}>
                    {resultList.length === 0 ? (
                        <div style={{padding: '6px 10px', fontSize: '11px', color: 'var(--txt)'}}>
                            {capitalizeFirstLetter(lang[props.languaje]['sinResultados'])}
                        </div>
                    ) : (
                        resultList.map((element, index) => {
                            const latStr = element.latitude || element.location_lat;
                            const lonStr = element.longitude || element.location_lon;
                            const isValid = validate(latStr, lonStr);
                            
                            return (
                                <div 
                                    key={index} 
                                    style={{
                                        padding: '6px 10px', 
                                        fontSize: '11px', 
                                        borderBottom: '1px solid var(--b1)', 
                                        cursor: isValid ? 'pointer' : 'not-allowed',
                                        background: isValid ? 'transparent' : '#fef2f2',
                                        color: isValid ? 'var(--txt)' : 'var(--red)'
                                    }}
                                    onClick={() => isValid ? handleSelected(element) : null}
                                    title={!isValid ? capitalizeFirstLetter(lang[props.languaje]['coordenadasErroneas']) : ''}
                                >
                                    <div><strong>{element.ip || element.hostid}</strong></div>
                                    <div>{props.ubiActual.dispId == -1 ? element.name : ((element.Host == undefined) ? (element.name || element.hostname) : element.Host)}</div>
                                </div>
                            );
                        })
                    )}
                </div>
            )}
        </div>
    );
}

export default SearchHost